import { render } from "./ViewSellerBets.vue?vue&type=template&id=79c9e6e4&scoped=true"
import script from "./ViewSellerBets.vue?vue&type=script&lang=js"
export * from "./ViewSellerBets.vue?vue&type=script&lang=js"

import "./ViewSellerBets.vue?vue&type=style&index=0&id=79c9e6e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c9e6e4"]])

export default __exports__